export const preferences = {
  title: 'Preferences',
  language: 'Language',
  theme: 'Theme',
  notifications: 'Notifications',
  saved: 'Preferences saved successfully',
};